import { render, staticRenderFns } from "./Part2.vue?vue&type=template&id=7cb31422&scoped=true"
var script = {}
import style0 from "./Part2.vue?vue&type=style&index=0&id=7cb31422&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cb31422",
  null
  
)

export default component.exports